<article>
  @if (isLoading) {
    <div>
      <div class="progress-materializecss">
        <div class="indeterminate"></div>
      </div>
    </div>
  }
  @for (asset of assets; track asset) {
    <div class="">
      <app-c3-chart [asset]="asset" [days]="7"></app-c3-chart>
    </div>
  }
</article>
